export function getDisplayName(displayName: string, name: string) {
  if (!displayName) return '';

  if (name === 'producttype') {
    return displayName.charAt(0).toUpperCase() + displayName.slice(1);
  }
  return displayName;
}
